// extracted by mini-css-extract-plugin
export var bodyContainer = "UYomZ";
export var header = "uKEvJ";